export const $ = {
  taskForm: document.querySelector("#taskForm"),
  taskInput: document.querySelector("#taskInput"),
  taskList: document.querySelector("#taskList"),
  searchInput: document.querySelector("#searchInput"),
  sortToggle: document.querySelector("#sortToggle"),
  sortLabel: document.querySelector("#sortLabel"),
  sortMenu: document.querySelector("#sortMenu"),
  themeToggle: document.querySelector("#themeToggle"),
  colorOptions: document.querySelectorAll(".color-option"),
  greeting: document.querySelector("#greeting"),
  taskSummary: document.querySelector("#taskSummary"),
  statTotal: document.querySelector("#stat-total"),
  statOpen: document.querySelector("#stat-open"),
  statDone: document.querySelector("#stat-done"),
  personalProgress: document.querySelector("#personalProgress"),
  quoteText: document.querySelector("#quoteText"),
  quoteAuthor: document.querySelector("#quoteAuthor"),
  exportBtn: document.querySelector("#exportBtn"),
  importBtn: document.querySelector("#importBtn"),
  importFileInput: document.querySelector("#importFile"),
  toasts: document.querySelector("#toasts"),
  shareQuoteBtn: document.querySelector("#shareQuoteBtn"),
  copyQuoteBtn: document.querySelector("#copyQuoteBtn"),
  copyQuoteBtnText: document.querySelector("#copyQuoteBtn span"),
  shareModal: document.querySelector("#shareModal"),
  overlay: document.querySelector("#overlay"),
  ogDescriptionMeta: document.querySelector('meta[property="og:description"]'),
  dot: document.querySelector(".cursor-dot"),
  taskTemplate: document.querySelector("#taskTemplate"),
  closeShareModalBtn: document.querySelector("#closeShareModal"),
  shareQuoteBtns: document.querySelectorAll(".share-quote-btn"),
};

export const ORIGINAL_OG_DESCRIPTION =
  $.ogDescriptionMeta?.getAttribute("content") ?? "";
